import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { AppInterface, setEditId, setEditError, selectAppById } from "src/store/community/appsSlice";
import { updateApp, fetchApp } from "src/actions/community/appsActions";
import { objToFormData } from "src/helpers/FormHelper";

import DrawerRight from "src/componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "src/componets/AlertBlock";

const Edit = () => {
  const dispatch = useAppDispatch();
  const id: any = useAppSelector(state => state.community.apps.editId);
  const error   = useAppSelector(state => state.community.apps.editError);
  const app  = useAppSelector(state => selectAppById(state, id));

  useEffect(() => {
    if (id) {
      dispatch(fetchApp(id));
    }
  }, [id, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(data: AppInterface) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: AppInterface) {
    const formData = objToFormData(data);
    const resultAction = await dispatch(updateApp({ id, data: formData }));

    if (updateApp.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-app'>
        <h6 className="v-content-label">Edit App</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form params={app} onFinish={onFinish} />
      </div>
    </DrawerRight>
  )
}

export default Edit;
